import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class CreditService {
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    private _credit: BehaviorSubject<number | null> = new BehaviorSubject(null);
    public credit$: Observable<number> = this._credit.asObservable();

    updateCredit(credit) {
        this._credit.next(credit);
    }

    public updatePaymentMethod(data: any): Observable<any> {
        const id = {idPaymentMethod: data};
        return this._httpClient.put('api/stripe/payment-method', id);
    }

    public getPaymentMethod(): Observable<any> {
        return this._httpClient.get('api/stripe/payment-method');
    }

    public createIntent(): Observable<any> {
        return this._httpClient.get('api/stripe/setup-intent');
    }

    public chargeAmount(amount): Observable<any> {
        return this._httpClient.post('api/stripe/charge', {amount});
    }

    public getBalance(): Observable<any> {
        return this._httpClient.get('api/stripe/balance');
    }

    /*
        public getUserSubscription(): Observable<any>{
            if (this.userSubscription) {
                return of (this.userSubscription);
            } else if (this.observableUserSubscription) {
                return this.observableUserSubscription;
            } else {
                this.observableUserSubscription = this.apiService.getAuthUserSubscription().pipe(
                    map((userSubscription: any) => {
                        this.userSubscription = userSubscription;
                        return this.userSubscription;
                    })
                );
                return this.observableUserSubscription;
            }
        }

        public getStripeCustomerInformation(id: number): Observable<any>{

            if (this.stripeCustomerInformation) {
                return of (this.stripeCustomerInformation);
            } else if (this.observableStripeCustomerInformation) {
                return this.observableStripeCustomerInformation;
            } else {

                this.observableStripeCustomerInformation = this.apiService.getAuthUserStripeDetail(id).pipe(
                    map((stripeCustomerInformation: any) => {
                        this.stripeCustomerInformation = stripeCustomerInformation;
                        return this.stripeCustomerInformation;
                    })
                );
                return this.observableStripeCustomerInformation;
            }
        }



        public clear(){
            this.userSubscription = null;
            this.stripeCustomerInformation = null;
            this.observableUserSubscription = null;
            this.observableStripeCustomerInformation = null;
            this.observableStatusSubscription = null;
            this.statusSubscription = null;
            this.observableStatusTrial = null;
            this.statusTrial = null;
            this.statusSubscriptionOneTime = null;
            this.observableStatusOneTimeSubscription = null;
        }


        public clearStripeInformation(clear:boolean = false){

            this.loaded = false;

            if(clear){
                this.clear();
            }

            this.hasUserActiveSubscription().subscribe((response: any) => {
                this.statusSubscriptionPublic = response;
            })

            this.hasUserActiveTrial().subscribe((response: any) => {
                this.statusTrialPublic = response;
            })

            this.hasUserActiveBranding().subscribe((response: any) => {
                this.statusSubscriptionOneTimePublic = response;
            })

            this.getUserSubscription().subscribe((response: any) => {
                this.userSubscriptionPublic = response;
                this.actualSubscriptionPublic = response.stripeSubscriptions.length > 0 ? response.stripeSubscriptions[0] : false;
                this.getStripeCustomerInformation(this.userSubscription.id).subscribe((res: any) => {
                    this.stripeCustomerInformationPublic = res;
                    this.loaded = true;
                });
            });
        }



        public openPaymentDialog(method : string, coupon: any, priceId : string ) {
            if(method=== 'card'){
                this.dialog.open(CardComponent, {
                    data: {
                        name: method,
                        userSubscription: this.userSubscription,
                        coupon: coupon,
                        priceId: priceId
                    },
                    width: '35%',
                    height : 'auto',
                    autoFocus: true
                })
            }

            /!*if(method=== 'bank'){
                this.dialog.open(BankaccountComponent, {
                    data: {
                        name: method,
                        userSubscription: this.userSubscription
                    },
                    width: '35%',
                    maxHeight: '350px',
                    height : 'auto',
                    autoFocus: true
                })
            }*!/
        }


        public openSubscriptionDialog(priceId:string) {
            this.dialog.open(SubscriptionOverviewComponent, {
                data: {
                    priceId: priceId
                },
                width: '50%',
                //autoFocus: true
            });
        }
    */


    /*public openProductDialog(coupon: any, paymentMethod: string | null, userId: string, priceId: string, cardIsReady: boolean = false) {
        this.dialog.open(ProductComponent, {
            data: {
                coupon: coupon,
                paymentMethod: paymentMethod,
                userId: userId,
                priceId: priceId,
                cardIsReady: cardIsReady
            },
            width: '35%',
            height : 'auto',
            autoFocus: true

        });
    }*/
}
